function Footer() {
  return (
    <footer>
      <h2>Contact me</h2>
      <div className="footer-links">
        <div>
          <a href="https://www.linkedin.com/in/aadeleye/" target="_blank">
            <i className="fa-brands fa-linkedin-in"></i>
            <p>linkedin.com/in/aadeleye/</p>
          </a>
        </div>
        <div>
          <a href="https://www.github.com/a-adeleye" target="_blank">
            <i className="fa-brands fa-github"></i>
            <p>github.com/a-adeleye</p>
          </a>
        </div>

        <div>
          <a href="mailto: adeleyeadeyemib@gmail.com">
            <i className="fa-solid fa-envelope"></i>
            <p>adeleyeadeyemib@gmail.com</p>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
